import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=13c16dfa&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainFooter.vue?vue&type=style&index=1&id=13c16dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c16dfa",
  null
  
)

export default component.exports